import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'pill': 'click' } };
    }
    click( e ){
        let active = e.currentTarget;
        if( active.classList.contains( 'active' ) ) return;
        active.parentNode.querySelector( '.active' ).classList.remove( 'active' );
        active.classList.add( 'active' );

        let query = '';
        [...this.el.querySelectorAll( '[data-pill-filters="pill"].active' )].forEach( pill => {
            if( pill.dataset.filterValue !== '0' ){
                query += `[data-filter-${pill.dataset.filterName}="${pill.dataset.filterValue}"]`;
            }

        });


        [ ...document.querySelectorAll( this.el.dataset.pillFiltersItems + query ) ].forEach( e => e.classList.remove( 'hidden' ) );
        [ ...document.querySelectorAll( this.el.dataset.pillFiltersItems + `:not(${query})` ) ].forEach( e => e.classList.add( 'hidden' ) );
    }

}
